"use strict";
var MergedRigidBodyList = (function () {
    function MergedRigidBodyList(axis) {
        this.axis = axis;
        this.bodies = [];
        this.resting = null;
    }
    MergedRigidBodyList.prototype.add = function (body) {
        this.bodies.push(body);
    };
    MergedRigidBodyList.prototype.getAverageVelocity = function () {
        // Total mass
        var totalMass = 0;
        var totalMassInfinity = 0;
        for (var _i = 0, _a = this.bodies; _i < _a.length; _i++) {
            var body = _a[_i];
            if (body.mass === Infinity) {
                totalMassInfinity += 1;
            }
            else {
                totalMass += body.mass;
            }
        }
        // Total momentum
        var totalMomentum = 0;
        var totalInfinityCoefficient = 0;
        for (var _b = 0, _c = this.bodies; _b < _c.length; _b++) {
            var body = _c[_b];
            if (body.mass === Infinity) {
                totalInfinityCoefficient += body.velocity[this.axis];
            }
            else {
                totalMomentum += body.mass * body.velocity[this.axis];
            }
        }
        if (totalMassInfinity) {
            return totalInfinityCoefficient / totalMassInfinity;
        }
        else {
            return totalMomentum / totalMass;
        }
    };
    MergedRigidBodyList.prototype.reset = function () {
        this.bodies.length = 0;
        this.resting = null;
    };
    return MergedRigidBodyList;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MergedRigidBodyList;
//# sourceMappingURL=MergedRigidBodyList.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/physics/lib/MergedRigidBodyList.js
 ** module id = 1174
 ** module chunks = 0
 **/